import React from 'react';

import Lock from '../../../common/Lock';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const EditOrLock = (props) => {
  const { permissions, permissionKey, action } = props;

  const { t } = useAutoTranslation();

  const currentPermission =
    permissions &&
    permissions.fieldPermissions &&
    permissions.fieldPermissions.find((p) => p.type === permissionKey);
  const editable = currentPermission ? currentPermission.value : true;
  const onClickAction = editable && action ? action : () => false;

  return (
    <div className="change-link" style={{ marginLeft: 'auto' }} onClick={onClickAction}>
      {editable ? t('Изменить') : <Lock reason={currentPermission.reason} />}
    </div>
  );
};

export default EditOrLock;
